import { Button } from '@wix/design-system';
import React from 'react';
import { DomainSearchGateModule } from '../../module/domainSearchGate.module';
import { useIsRecommendationsListActive } from '../Recommendations/RecommendationsListActivity';
import recommendationsStyles from '../Recommendations/Recommendations.css';
import { SearchedDomainBrokerDataHooks } from './dataHooks';
import { useHireBroker } from './useHireBroker';
export const HireBrokerButton = _ref => {
  let domainName = _ref.domainName;
  const _DomainSearchGateModu = DomainSearchGateModule.internals.useTranslations(),
    t = _DomainSearchGateModu.t;
  const hireBroker = useHireBroker(domainName);
  const isRecommendationsListActive = useIsRecommendationsListActive();
  return /*#__PURE__*/React.createElement(Button, {
    skin: "dark",
    size: "medium",
    priority: isRecommendationsListActive ? 'secondary' : 'primary',
    className: recommendationsStyles.GetItButton,
    onClick: hireBroker,
    dataHook: SearchedDomainBrokerDataHooks.hireBrokerButton
  }, t('domain_search_gate.results.searched_domain.status.broker.cta'));
};
//# sourceMappingURL=HireBrokerButton.js.map